import {gql} from "@apollo/client";

export const DELETE_AND_INSERT_ELECTIVE_CHOICES_BY_PERSON_ID = gql`
    mutation delete($person_id: Int!, $elective_choices: [grid_elective_choice_insert_input!]!) {
      delete_grid_elective_choice(where: {person_id: {_eq: $person_id}}) {
        affected_rows
      }
      insert_grid_elective_choice(objects: $elective_choices) {
         affected_rows
      }     
    }`

export const DELETE_ELECTIVE_CHOICE = gql`
    mutation delete($course_id: Int!, $person_id: Int!, $speciality_id: Int!) {
      delete_grid_elective_choice_by_pk(course_id: $course_id, person_id: $person_id, speciality_id: $speciality_id) {
        person_id
        course_id
        speciality_id
      }    
    }`

export const INSERT_ELECTIVE_CHOICES_BY_PERSON_ID = gql`
    mutation insert($elective_choices_to_add: [grid_elective_choice_insert_input!]!) {
      insert_grid_elective_choice(objects: $elective_choices_to_add) {
         affected_rows
      }     
    }`